<template>
  <div class="page">
    <!-- 搜索 -->
    <el-form
      v-if="isSearch"
      :model="queryForm"
      ref="form"
      label-width="80px"
      :inline="true"
      size="small"
      class="query-form"
      @submit.native.prevent
    >
      <el-form-item label="发送者">
        <GridSelect
          style="width: 180px"
          title="选择发送者"
          labelName='userName'
          labelValue='id'
          :value="queryForm.sendUserId"
          :limit="1"
          size="small"
          placeholder="请选择发送者"
          @getValue='(value) => {queryForm.sendUserId = value}'
          :columns="USER_code"
          :searchs="USER_search"
          dataListUrl="/mpp/user/findList"
          entityBeanName="mppUser"
          queryEntityUrl="/mpp/user/get"
        >
        </GridSelect>
      </el-form-item>
      <el-form-item label="接收者">
        <GridSelect
          style="width: 180px"
          title="选择接收者"
          labelName='userName'
          labelValue='id'
          :value="queryForm.acceptUserId"
          :limit="1"
          size="small"
          placeholder="请选择接收者"
          @getValue='(value) => {queryForm.acceptUserId = value}'
          :columns="USER_code"
          :searchs="USER_search"
          dataListUrl="/mpp/user/findList"
          entityBeanName="mppUser"
          queryEntityUrl="/mpp/user/get"
        >
        </GridSelect>
      </el-form-item>
      <el-form-item label="消息内容">
        <el-input
          v-model="queryForm.messageContent"
          placeholder="请填写消息内容"
          style="width: 180px"
        ></el-input>
      </el-form-item>
      <el-form-item label="消息类型">
        <el-select
          placeholder="请选择消息类型"
          clearable
          v-model="queryForm.requestType"
          style="width: 180px"
        >
          <el-option
            v-for="type in messageTypeList"
            :key="type.key"
            :label="type.value"
            :value="type.key"
          > </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="离线消息">
        <el-select
          placeholder="请选择离线消息"
          clearable
          style="width: 180px"
          size="small"
          v-model="queryForm.isOffline"
        >
          <el-option
            label="离线"
            :value="1"
          >
          </el-option>
          <el-option
            label="在线"
            :value="0"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          style="width: 180px"
          v-model="timeRange"
          type="datetimerange"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="-"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item style="margin-left: 80px">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="getRequestList"
        >查询</el-button>
        <el-button
          size="small"
          icon="el-icon-refresh"
          @click="resetDialog"
        >重置</el-button>
      </el-form-item>
    </el-form>
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="el-btn-group">

        </div>
        <div class="icon-group">
          <span
            title="搜索"
            class="icon-box"
            @click="search"
          >
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
          <span
            class="icon-box"
            @click="refreshRequestList"
          >
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <!-- 请求消息列表-->
      <el-table
        :data="requestList"
        width="100%"
        row-key="id"
        size="small"
        height="50%"
        @selection-change="handleSelectionChange"
        :default-expand-all="true"
      >
        <el-table-column
          align="center"
          type="selection"
          min-width="5%"
        > </el-table-column>
        <el-table-column
          align="center"
          label="发送者"
          prop="sendUser.userName"
          min-width="12%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="acceptUser.userName"
          label="接收者"
          min-width="12%"
        > </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="isOffline"
          label="离线消息"
          min-width="5%"
        >
          <template slot-scope="scop">
            {{scop.row.isOffline == 0 ? '否' : '是'}}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="requestType"
          label="请求类型"
          min-width="10%"
        >
          <template slot-scope="scop">
            {{scop.row.requestType !== null ? getMessageDesc(scop.row.requestType) : '--'}}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="requestMessage"
          label="消息内容"
          min-width="20%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="创建时间"
          min-width="11%"
        >
          <template slot-scope="scpe">
            {{$moment(scpe.row.createTime).format('YYYY-MM-DD HH:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作"
          min-width="10%"
        >
          <template slot-scope="scop">
            <div class="operation">
              <div @click="checkRequestMessage(scop.row.requestId)">
                <Icon size="16">
                  <Eye24Regular />
                </Icon>
                <span class="operation-label">查看</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
          :pager-count="7"
        >
        </el-pagination>
      </div>
      <!-- 查看请求详情-->
      <el-dialog
        :title="''"
        :visible.sync="showDialog"
        width="60%"
        @close="closeDialog"
      >
        <div>
          <el-form
            :model="requestMessage"
            ref="requestMessageForm"
            :rules="rules"
            label-width="120px"
            :inline="true"
            size="mini"
          >
            <el-form-item
              label="发送者"
              prop="sendUserId"
              v-if="requestMessage.sendUser !== null "
            >
              <el-input
                size="small"
                v-model="requestMessage.sendUser.userName"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="接收者"
              prop="acceptUserId"
              v-if="requestMessage.acceptUserId !== null "
            >
              <el-input
                size="small"
                v-model="requestMessage.acceptUser.userName"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="离线消息"
              prop="isOffline"
            >
              <el-select
                style="width : 175px"
                size="small"
                v-model="requestMessage.isOffline"
                :disabled="true"
              >
                <el-option
                  label="在线"
                  :value="0"
                >
                </el-option>
                <el-option
                  label="离线"
                  :value="1"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="消息类型"
              prop="requestType"
            >
              <el-select
                style="width : 175px"
                size="small"
                v-model="requestMessage.requestType"
                :disabled="true"
              >
                <el-option
                  v-for="messageType in messageTypeList"
                  :key="messageType.key"
                  :label="messageType.value"
                  :value="messageType.key"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="创建时间"
              prop="createTime"
            >
              <el-input
                size="small"
                v-model="$moment(requestMessage.createTime).format('YYYY-MM-DD HH:mm:ss')"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="消息行为"
              prop="requestMessage"
            >
              <el-select
                style="width : 175px"
                size="small"
                v-model="requestMessage.message.actionType"
                :disabled="true"
              >
                <el-option
                  v-for="actionType in actionTypeList"
                  :key="actionType.key"
                  :label="actionType.value"
                  :value="actionType.key"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="所用设备"
              prop="requestMessage"
            >
              <el-select
                style="width : 175px"
                size="small"
                v-model="requestMessage.message.deviceType"
                :disabled="true"
              >
                <el-option
                  v-for="deviceType in deviceTypeList"
                  :key="deviceType.key"
                  :label="deviceType.value"
                  :value="deviceType.key"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="消息内容"
              prop="requestMessage"
            >
              <el-input
                type="textarea"
                :rows="3"
                size="small"
                v-model="requestMessage.requestMessage"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>

        <div
          slot="footer"
          class="flex justify-end"
        >
          <el-button @click="closeDialog">关闭</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelect from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from "@/utils/constant"
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelect
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetRequestList();
                this.getRequestList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetRequestList();
                this.getRequestList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            USER_code: USER,
            USER_search: USER_SEARCH,
            timeRange: [],
            queryForm: {
                sendUserId: '', //发送者名称
                acceptUserId: '', //接受者
                messageContent: '', //消息内容
                requestType: '', //消息类型
                isOffline: '', //是否在线
                startTime: '', //开始时间
                endTime: '' //结束时间
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopMoneyRecordState: 'add',
            shopMoneyRecordStates: {
                add: '',
                check: '查看',
                edit: '修改朋友'
            },

            multipleSelection: [],
            requestList: [],
            messageTypeList: [],
            actionTypeList: [],
            deviceTypeList: [],
            btnLoading: false,
            requestMessage: {
                //请求详情
                sendUserId: '',
                acceptUserId: '',
                sendUser: {},
                acceptUser: {},
                requestMessage: '',
                requestType: '',
                isOffline: '',
                createTime: '',
                message: {}
            },
            rules: {}
        };
    },
    created() {
        this.getRequestList();
        this.getMessageType();
        this.getActionType();
        this.getDeviceType();
    },
    methods: {
        //获取消息类型标签
        getMessageDesc(messageType) {
            for (const index in this.messageTypeList) {
                if (this.messageTypeList[index].key == messageType) {
                    return this.messageTypeList[index].value;
                }
            }
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetRequestList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.requestList = [];
        },
        resetDialog() {
            this.shopMoneyRecordState = 'add';
            this.showDialog = false;
            this.queryForm = {
                sendUserId: '', //发送者名称
                acceptUserId: '', //接受者
                messageContent: '', //消息内容
                requestType: '', //消息类型
                isOffline: '', //是否在线
                startTime: '', //开始时间
                endTime: '' //结束时间
            };
            this.timeRange = [];
            this.getRequestList();
        },
        closeDialog() {
            this.resetDialog();
            this.resetProperty();
        },
        //重置字段
        resetProperty() {
            this.requestMessage = {
                sendUserId: '',
                acceptUserId: '',
                sendUser: {},
                acceptUser: {},
                requestMessage: '',
                requestType: '',
                isOffline: '',
                createTime: '',
                message: {}
            };
        },
        //查看
        checkRequestMessage(currentId) {
            this.getRequestMessage(currentId);
            if (this.requestMessage) {
                this.showDialog = true;
            }
        },
        //请求详情
        getRequestMessage(id) {
            get(`/im/friend/get`, { requestId: id }).then((res) => {
                if (res.success && res.code == 200) {
                    this.requestMessage = { ...this.requestMessage, ...res.requestMessage };
                    if (this.requestMessage && this.requestMessage.requestMessage) {
                        let message = JSON.parse(this.requestMessage.requestMessage);
                        this.requestMessage.message = message;
                    }
                }
            });
        },
        refreshRequestList() {
            this.resetRequestList();
            this.getRequestList();
        },
        getRequestList() {
            if (this.timeRange != null) {
                this.queryForm.startTime = this.timeRange[0];
                this.queryForm.endTime = this.timeRange[1];
            }
            get(`/im/friend/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.requestList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getRequestList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getRequestList();
        },
        //获取消息类型
        getMessageType() {
            get(`/im/utils/getEnum`, { enumType: `message_type` }).then((res) => {
                if (res.success) {
                    this.messageTypeList = res.enumList;
                }
            });
        },
        //获取设备类型
        getActionType() {
            get(`/im/utils/getEnum`, { enumType: `action_type` }).then((res) => {
                if (res.success) {
                    this.actionTypeList = res.enumList;
                }
            });
        },
        //获取行为类型
        getDeviceType() {
            get(`/im/utils/getEnum`, { enumType: `device_type` }).then((res) => {
                if (res.success) {
                    this.deviceTypeList = res.enumList;
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
.moneyRecord-table-expand {
    font-size: 0;
    margin-top: -20px;
}
.moneyRecord-table-expand label {
    width: 90px;
    color: #99a9bf;
}
.moneyRecord-table-expand .el-form-item {
    margin-left: 4%;
    margin-bottom: -1%;
    width: 100%;
}
</style>